import { CP06_BLOOD_PRESSURE_SURFACE } from "./medical-evidence";

// TES-911/TES-909 — where a measurement came from, in the doctor's words.
// Lifted out of the admin's transfer review (TES-978) so the monthly journal's
// prefill names a reading's source with the same words the doctor already
// reads there.
//
// An unknown value is shown raw rather than swallowed: a row written by a
// generation this code has not met is still evidence, and hiding its origin
// would make it look like it had none.
export const MEASUREMENT_SOURCE_LABEL: Record<string, string> = {
  patient: "patientens egen registrering",
  form: "inskickat formulär",
  clinician: "registrerad av vårdpersonal",
  import: "importerad",
};

// "F-07 och CP-06 får förekomma som interna källidentifierare, men inte som handlingsspråk för Kirill eller patienten."
export const MEASUREMENT_SURFACE_LABEL: Record<string, string> = {
  [CP06_BLOOD_PRESSURE_SURFACE]: "begärd komplettering",
  "health/trends": "Din hälsa över tid",
  "F-07": "receptövertagsformuläret",
  F07_INITIAL: "receptövertagsformuläret",
  F07_COMPLETION: "receptövertagsformuläret, komplettering",
  "F-02": "hälsodeklarationen",
  // TES-985 — a reading she entered or changed in the monthly check-in.
  "F-05": "månadsincheckningen",
};

export function measurementSourceLabel(r: {
  source: string;
  sourceSurface: string | null;
}): string {
  const base = MEASUREMENT_SOURCE_LABEL[r.source] ?? r.source;
  if (!r.sourceSurface) return base;
  const surface = MEASUREMENT_SURFACE_LABEL[r.sourceSurface] ?? r.sourceSurface;
  return `${base} · ${surface}`;
}
